import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SigninService } from 'src/app/services/signin.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-log',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  log: any; isLoginError: boolean; res: any; returnUrl: string;
  constructor(private _api: SigninService, private router: Router, private route: ActivatedRoute, private _msg: ToastrService) { }

  ngOnInit() {
    this.resetLogin();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    // console.log(this.returnUrl);
  }

  login() {
    this._api.loginUser(this.log).subscribe((data: any) => {
      localStorage.setItem('Token', JSON.stringify(data.access_token));
      localStorage.setItem('Date', JSON.stringify(data.date));
      // this.router.navigate([this.returnUrl]); location.reload(true);
      window.location.href = this.returnUrl;
    }, (err: HttpErrorResponse) => { 
      this.isLoginError = true; console.log(err);
      this.res = 'Incorrect Username or Password'; });
  }

  resetLogin(form?: NgForm) {
    if (form != null) { form.reset(); }
    this.log = { username: '', password: '' };
  }

}
